/**
 * section-custom-packaging-about.js
 * Animación de entrada escalonada para la sección Quiénes somos.
 * Cada elemento con .pkg-about__anim-el y data-delay="N"
 * aparece con N * STAGGER_MS de delay al entrar al viewport.
 */

(function () {
  'use strict';

  var STAGGER_MS  = 110;
  var THRESHOLD   = 0.12;
  var ROOT_MARGIN = '0px 0px -48px 0px';

  function initAbout(section) {
    var els = section.querySelectorAll('.pkg-about__anim-el');
    if (!els.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        var el    = entry.target;
        var delay = (parseInt(el.dataset.delay, 10) || 0) * STAGGER_MS;

        setTimeout(function () {
          el.classList.add('is-visible');
        }, delay);

        observer.unobserve(el);
      });
    }, {
      threshold:  THRESHOLD,
      rootMargin: ROOT_MARGIN
    });

    els.forEach(function (el) { observer.observe(el); });
  }

  function init() {
    document
      .querySelectorAll('.section-custom-packaging-about')
      .forEach(initAbout);
  }

  /* Soporte Theme Editor de Shopify */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.section-custom-packaging-about');
    if (section) initAbout(section);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
